<template>
  <div>
    <h2>Reset Password</h2>
    <h4>User has set password: {{ user.has_set_password ? 'Yes' : 'No' }}</h4>
    <el-button
      @click.native="initiatePasswordRecovery()"
    >
      Send Password Reset
    </el-button>
  </div>
</template>
<script>
import Request, { POST } from '@/plugins/sdk/Request'

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isRecoveringPassword: false
    }
  },
  methods: {
    async initiatePasswordRecovery () {
      this.isRecoveringPassword = true

      const request = await (Object.assign(new Request(), {
        method: POST,
        _pathname: 'authenticate/forgot',
        body: {
          email: this.user.email
        }
      })).build()

      const response = await fetch(request)

      if (response.ok) {
        this.$message.success('A password recovery email has been sent')
      }

      this.isRecoveringPassword = false
    }
  }
}
</script>
